module.exports = __webpack_public_path__ + "static/media/cyroth_nano.e4059079.png";